// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"0de46324d3dd1dad","777":"db133aaf99624baa"}[chunkId] + ".js";
};